<template>
  <section>
    <h2 class="mb-3 text-center">About Us</h2>
    <div class="about-us-row">
      <img src="../../assets//images/about-us-img.jpg" alt="About Us" />
      <div class="text-container">
        <p>
          PICS N CART is an emerging one-stop platform for photography enthusiasts and professionals across India. Founded by a team of passionate photographers in Udupi, Karnataka, we aim to bring together the photography community through learning, sharing, and showcasing
        </p>
        <p>
          What began as a grassroots initiative is now a growing platform offering:
          <ul>
            <li>
              Engaging photography contests
              </li>
              <li>

                Hands-on workshops & tutorials by industry experts
              </li>
<li>
  Professional photographer profiles to showcase your work

</li>
<li>
Reliable services and community support
            </li>
          </ul>
        </p>
        <p>
          Our future roadmap includes:
          <ul>
            <li>
              A full-fledged online store for cameras and accessories from leading brands
            </li>
            <li>
              A curated stock photography marketplace for contributors and buyers
            </li>
          </ul>
        </p>

        <p>
          At PICS N CART, we believe photography deserves a dedicated space—and we’re here to build it.
        </p>
      </div>
    </div>
    <!-- <h3>Our Services</h3>
    <ul>
      <li>Cameras and accessories</li>
      <li>Photography tutorials</li>
      <li>Photography competition</li>
      <li>Pages for photographer's profile</li>
    </ul> -->
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.about-us-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 2rem;
}

.about-us-row img {
  width: 40%;
  height: auto;
}

.about-us-row .text-container {
  width: 50%;
}
@media screen and (max-width: 600px) {
  p {
    text-align: justify;
  }

  .about-us-row img {
    width: 100%;
    height: 360px;
    object-fit: cover;
  }

  .about-us-row .text-container {
    width: 100%;
    margin-top: 2rem;
  }
}
</style>